<template>
  <!-- 眼科学员登录layout -->
  <div class="user-layout-wrapper">
    <!-- footer -->
    <div class="left-wrap">
      <!-- <img class="left-wrap-bg" src="~@/assets/login_bg.png" width="100%" /> -->
      <!-- content -->
      <div class="left-content">
        <div class="flex-box">
          <img src="~@/assets/logo-layout-eye.png" width="80px" />
          <!-- <h2 class="pro-title">国家基层儿童青少年近视防控人员培训项目</h2> -->
          <h2 class="pro-title-two">明眸学苑</h2>
          <div class="content-wrap">
            <div class="item-wrap">
              <div class="item-block">
                <!-- 2023.6.15修改 -->
                <!-- <div class="item">
                  <span>指导单位: </span>
                  <span>国家卫生健康委员会</span>
                </div>
                <div class="item">
                  <span>主办单位: </span>
                  <span>中华医学会</span>
                </div> -->
                <div class="item">
                  <span>主办单位: </span>
                  <span>国家眼部疾病临床医学研究中心 上海医疗质量研究中心</span>
                </div>
                <!-- 2023.6.15修改 -->
                <!-- <div class="item">
                  <span>承办单位: </span>
                  <span>中华医学会眼科学分会 &nbsp; 中华医学会继续教育部</span>
                </div>
                <div class="item flex">
                  <span>实施单位: </span>
                  <span style="margin-left: 4px"
                    >国家眼部疾病临床医学研究中心 上海市眼病防治中心
                    上海交通大学附属第一人民医院 上海医疗质量研究中心<br />
                    上海市视觉健康中心（上海市儿童青少年近视防治技术中心）</span
                  >
                </div> -->
                <div class="item flex">
                  <span>支持单位: </span>
                  <div>
                    <span
                      >上海市眼病防治中心
                      上海交通大学医学院附属第一人民医院</span
                    >
                    <span style="display: block; margin-top: 6px"
                      >上海市视觉健康中心（上海市儿童青少年近视防治技术中心)</span
                    >
                  </div>
                  <!-- <span style="margin-left: 4px"
                    >上海市眼病防治中心 上海交通大学医学院附属第一人民医院<br />
                    上海市视觉健康中心（上海市儿童青少年近视防治技术中心)</span
                  > -->
                </div>
                <div class="flex-wrap" style="margin-top: 36px">
                  <div style="margin-right: 10px">
                    <div class="item">
                      <span></span>
                      <!-- 2023.6.15修改 -->
                      <!-- <a href="https://beian.miit.gov.cn"
                        >沪ICP备2020032025号-2</a
                      > -->
                      <a href="https://beian.miit.gov.cn"
                        >沪ICP备 14051536号-5</a
                      >
                    </div>
                  </div>
                  <div class="item">
                    <span>联系电话：</span>
                    <span>13761578223</span>
                  </div>
                </div>
                <div class="item">
                  <span
                    >为了更好的网站体验，建议您使用谷歌、火狐、IE9及以上版本、360极速模式等高版本的浏览器</span
                  >
                </div>
              </div>
            </div>
            <!-- <div class="item-wrap">
            <div class="flex-center">
              <img
                src="~@/assets/eye/footer-logo.png"
                style="max-width:100%;width:475px;"
              />
            </div>
          </div> -->
          </div>
        </div>

        <div class="qr-code">
          <div class="code">
            <img :src="qrUrl" alt="qrcode" width="60" height="60" />
            <div class="tip">明眸学苑</div>
          </div>
          <div class="code" style="margin-right: 6px">
            <img
              src="~@/assets/user_layout/login-code.jpg"
              alt="qrcode"
              width="60"
              height="60"
            />
            <div class="tip">技术支持</div>
          </div>
          <div class="code">
            <img
              src="~@/assets/eye/jiceng.jpg"
              alt="qrcode"
              width="60"
              height="60"
              style="margin: 0 auto"
            />
            <div class="tip" style="text-align: center">基层医学教学平台</div>
          </div>
        </div>
      </div>
    </div>
    <div class="user-view"><router-view></router-view></div>
  </div>
</template>

<script>
export default {
  name: "UserLayout",
  data() {
    return {
      qrUrl: ""
    };
  },
  created() {
    this.qrUrl = require(process.env.VUE_APP_Qrcode);
  }
};
</script>

<style lang="less" scoped>
.user-layout-wrapper {
  min-height: 500px;
  height: 100%;
  display: flex;
  .user-view {
    flex-grow: 1;
    height: 100%;
    display: flex;
  }
  .left-wrap {
    background-image: url("../../src/assets/left-bg.png");
    width: 50%;
    height: 100%;
    position: relative;
    background-position: -3px -1px;
    background-repeat: no-repeat;
    background-size: cover;
    .left-content {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 20px 0;
      .flex-box {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      .pro-title {
        color: #ffffff;
        font-weight: bold;
        margin: 30px 0 76px 0;
      }
      .pro-title-two {
        margin-top: 27px;
        margin-bottom: 97px;
        font-size: 26px;
        font-weight: 600;
        color: #ffffff;
        line-height: 37px;
        letter-spacing: 8px;
      }
      .qr-code {
        align-items: center;
        display: flex;
        padding: 0 20px;
        width: 424px;
        .code {
          flex: 1;
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          // align-items: left;
          justify-content: center;
          .tip {
            width: 120px;
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
            text-align: left;
            margin-top: 10px;
          }
        }
      }
      .content-wrap {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: 1px;
        display: flex;
        .item-block {
          padding: 6px 20px;
          .item {
            padding: 4px 0;
            a {
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
            }
          }
        }
      }
    }
  }
}
</style>
